import * as React from "react";
import { ComplaintContainer } from "../complaint/Complaint.styled";
import { ButtonSecondary } from "../login.screen/login.styled";
import { MiniNav, MoveInHeader } from "../MoveIn.screen/MoveIn.styled";
import { TabWithCount } from "../SocialCase/SocialCase";
import { Box, Modal, Tab, Tabs } from "@mui/material";
import { a11yProps } from "../Tabs.MUI/Tabs.interface";
import { TabPanel } from "../MoveInRegistration/MoveInRegistration";
import PropertyDetails from "../../components/MoveOutTerminationTabs/PropertyDetailsTab";
import Reviews from "../../components/MoveOutTerminationTabs/Reviews";
import VerifyAndPay from "../../components/MoveOutTerminationTabs/VerifyAndPay";
import MoveInOut, { MoveOutData } from "../../stores/MoveInOutStore";
import User from "../../stores/UserStore";
import { useState, useRef, useEffect } from "react";
import { observer } from "mobx-react";
import AccountsNotifications from "../../stores/AccountsNotificationsStore";
import { GatewaySelection } from "../../components/MoveOutTerminationTabs/GatewaySelection";
import { ACTIVE_PAYMENT_GATEWAY } from "../../utils/constants";

import CardsPopup from "../../components/MoveOutTerminationTabs/CardsPopup";
import CardsStore from "../../stores/CardsStore";

import moment from "moment";
import General from "../../stores/GeneralStore";
import { toJS } from "mobx";
import Thankyou from "../../components/SocialCaseTbas/Thankyou";
import { useLocation } from "react-router-dom";
import { truncate } from "fs/promises";
import moveInOutStore from "../../stores/MoveInOutStore";
import { useNavigate } from "react-router-dom";
import { NotifyError } from "../../utils/ShowError";
import MoveIn from "../MoveIn.screen/MoveIn.screen";
import nocsRequestsStore from "../../stores/NocsRequestsStore";

interface Obj {
  [key: string]: any;
}

interface AppConfig {
  "isCheckout" : boolean
}

const MoveOutTermination = () => {
  const [value, setValue] = useState(0);
  const [submit, setSubmit] = useState(false);
  const [openCards, setOpenCards] = useState(false);
  const [validateLoader, setValidateLoader] = useState(false);
  const [duesLoader, setduesLoader] = useState(false);
  const [sewerageValue, setSewerageNumber] = useState("");
  const [fileUpload, setFileUpload] = useState(false);
  const [message, setMessage] = useState("");
  interface StatusMessage {
    message?: string;
    caseId?: string;
  }
  
  const [statusMessage, setStatusMessage] = useState<StatusMessage>({});
  const [serviceId,setServiceId] = useState(6); // 6 for MoveOut

  const navigate = useNavigate();

  const location = useLocation();
  const orderIDParam = location?.state?.id;

  const isCheckoutActive = ACTIVE_PAYMENT_GATEWAY === 'CHECKOUT';
  
  const [config, setConfig] = useState<AppConfig | null>(null);
    
        useEffect(() => {
            async function loadConfig() {
              try {
                const response = await fetch('/config/config.json'); 
                const json = await response.json();
                setConfig(json);
              } catch (err) {
                console.error("Error loading config:", err);
              }
            }
            loadConfig();
          }, []);

  let accountNumber = "";

  const handleGetCardsList = async () => {
  await CardsStore.getCardsList({ errorId: "getCardsListError" });
  };
   useEffect(() => {
    handleGetCardsList();
   },[])

  const sewerageNumberRef = useRef<HTMLSelectElement | null>(null);
  const handleGetDetails = async () => {
    setValidateLoader(true)
    MoveInOut?.removeMoveOutDues()
    if (sewerageNumberRef.current && sewerageNumberRef.current?.value) {
      const index: number = parseInt(sewerageNumberRef.current!.value);
      const sewerageNumber = MoveInOut.sewerageNumbers[index].key;
      setSewerageNumber(sewerageNumber);
      await MoveInOut.validateMoveOut({
        errorId: "validateMoveOutError",
        data: sewerageNumber,
      });
      console.log("moveoutinfo", MoveInOut.moveOutInfo);
      await checkMoveOutApprovalEligibilityFlow(MoveInOut.moveOutInfo);
      setValidateLoader(false)
      return true;
      // const {result:{totalAmount}} = await MoveInOut.getMoveInDue(sewerageNumberRef.current!.value, User.info.personId)
      // paymentDue = totalAmount>0
      //setValue(1);
    } else {
      setValidateLoader(false)
      return false;
    }
  };
  const checkMoveOutApprovalEligibilityFlow = async (moveOutInfo:any) => { 
    const { accountId, premiseId } = moveOutInfo;
    let approvalCaseStatus = "";
    setMessage("");
    try { 
      await MoveInOut.checkMoveOutApprovalEligibility({
        errorId: "checkMoveOutError",
        data: { accountId, premiseId },
      });
      approvalCaseStatus = MoveInOut.moveOutEligibility.approvalCaseStatus ? MoveInOut.moveOutEligibility.approvalCaseStatus.toUpperCase() : null;
      if (MoveInOut.moveOutEligibility.isEligibleForMoveOutApprovalFlow === "Y") {
        setFileUpload(true);
        return;
      }
      else {
        if (MoveInOut.moveOutEligibility.status === "0" && approvalCaseStatus === null)
        {
          setFileUpload(false);
          return;
        }
        if(approvalCaseStatus === "CASE REJECTED / CANCELLED") {
          setFileUpload(true);
          return;
        }
        if(approvalCaseStatus === "CASE COMPLETED / CLOSED") {
          return;
        }
        else {
          if(MoveInOut.moveOutEligibility.message) {
            setFileUpload(false);
            setMessage(MoveInOut.moveOutEligibility.message);
          }
          else {
            setMessage(General?.codeLabels["cm_mo_approval_request_failed"]?.label ? General?.codeLabels["cm_mo_approval_request_failed"]?.label : "Move Out Approval Request Failed. Please try again later.")
          }
        }
      }
    } catch (error) {
      console.log("error in uploading the documents", error);
     }
  }
  const handleUploadDocs = async (payload : any) => {
    console.log("payload recievd from th child", payload);
    try {
      const result = await MoveInOut.uploadMoveOutDocuments({
        errorId: "uploadMoveOutDocumentsError",
        data: payload,
      }).catch((error) => { 
        console.log("error in uploading the documentsddffff", error);
        NotifyError(
          "Move Out Approval Request Failed. Please try again later."
         );
       
      });

      if (result) {       
        console.log("result of upload", result);
        setStatusMessage(result);
        setServiceId(4)
        setValue(3);
      }
    }
    catch (error) {
          NotifyError(
               "Move Out Approval Request Failed. Please try again later."
              );
      
      console.log("error in uploading the documents", error);
    }
  }

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    // setValue(newValue);
  };
  const handleSubmit = (e?: any) => {
    setSubmit(true);
  };

  const handleCardsModalClose = () => {
    setOpenCards(false);
  };

  const loadMoveOutDues = async () => {
    setduesLoader(true)
    try {
      await MoveInOut.getMoveOutDue();
      setduesLoader(false)

    }
    catch (error:any) {
      // console.log("error in due is",error?.error?.[0]?.message)
    
      let errorMessage  = error?.error?.[0]?.message.toLowerCase();
;
      setduesLoader(false)
      NotifyError(General?.codeLabels[`cm_${errorMessage}`]?.label ? General?.codeLabels[`cm_${errorMessage}`]?.label : "Active Tenant found in Premise, your request can not be processed. Please contact customer service for more details.")
      setValue(0)
    }

    //serviceTerminationDate
    //accountId
  };

  const loadSewerageNumber = async () => {
    await MoveInOut.getMoveOutProperties({
      errorId: "getMoveOutPropertiesError",
    });
  };

  // const handleCardChosen = ()=>{
  //   console.log("***ewwwwwww")
  //   setOpenCards(false)
  //   //moveout
  // }

  const moveOutOtpVerified = (transactionId: string) => {
    // setValue(2);

    console.log(
      "***MoveInOut.moveOutDues.totalAmountTobePaid:",
      MoveInOut.moveOutDues.totalAmountTobePaid
    );
    // setOTPModalOpen(false)
    if (MoveInOut.moveOutDues.totalAmountTobePaid > 0) setOpenCards(true);
    else {
      handleMoveOut();
      console.log("***moving out");
      //moveout
    }
  };

  const paymentDataForGateway = {
    token: "",
    amount: MoveInOut.moveOutDues.totalAmountTobePaid,
    type: "moveOut",
    sewerageId: MoveInOut.moveOutInfo.premiseId,
    serviceTerminationDate: MoveInOut.moveOutInfo.serviceTerminationDate,
    isNOCSelected: MoveInOut.moveOutDues.isNOCSelected,
    accountId: MoveInOut.moveOutInfo.accountId,
    estimatedBillId: MoveInOut.moveOutDues.estimatedBillId,
    customerAddress: MoveInOut.moveOutInfo.customerAddress,
    platform: "web",
    returnUrl: `${window.location.origin}/Payment/ExternalRedirect`,

    paymentRequestType: 1,

  }
   const handlePaymentInitiation = async (payload: any, gatewayType: string) => {
    if(gatewayType === 'ni'){
 const res = await MoveInOut.NImoveOutPayment(payload);

    if (res?.message === "Success") {
      return res; 
    } else {
      throw new Error(res?.message || "Payment failed. Please try again");
    }
    }
    if(gatewayType === 'tabby'){
      const res = await MoveInOut.TabbymoveOutPayment(payload);

    if (res?.message === "Success") {
      return res; 
    } else {
      throw new Error(res?.message || "Payment failed. Please try again");
    }
    }
    if(gatewayType === 'tamara'){    
        const res = await MoveInOut.TamaramoveOutPayment(payload);
    
        if (res?.message === "Success") {
          return res; 
        } else {
          throw new Error(res?.message || "Payment failed. Please try again");
        }
      }
}

const checkTabbyEligibility = async (payload: any) => {
  try {
    const response = await MoveInOut.makeTabbyEligibilityCheck({
            errorId: "tabbyEligibilityCheckError",
            data: payload,
          });
    // return !!response?.result?.isEligible;
    const isEligible = !!response?.result?.isEligible;
    const message = response?.result?.message || "";
const isAmountEligible = response?.result?.isAmountEligible;

    return { isEligible, message, isAmountEligible };
  } catch (error) {
    console.error("Eligibility check failed:", error);
    return false;
  }
};

const checkTamaraEligibility = async (payload: any) => {
  try {
    const response = await nocsRequestsStore.makeTamaraEligibilityCheck({
            errorId: "tamaraEligibilityCheckError",
            data: payload,
          });
    const message = response?.result?.message || "";
const isAmountEligible = response?.result?.isAmountEligible;

    return {message, isAmountEligible };
  } catch (error) {
    console.error("Tamara eligibility check failed:", error);
    return false;
  }
};

  const handleMoveOut = async () => {
    const moveOutInfo = MoveInOut.moveOutInfo;
    const moveOutDues = MoveInOut.moveOutDues;

    const data = {
      estimatedBillId: moveOutDues.estimatedBillId,
      accountId: moveOutInfo.accountId,
      isNOCSelected: moveOutDues.isNOCSelected,
      premiseId: moveOutInfo.premiseId,
      serviceTerminationDate: moveOutInfo.serviceTerminationDate,
      customerAddress: moveOutInfo.customerAddress,
    };
    try {
      const res = await MoveInOut.moveOut({ errorId: "moveOutError", data });
      if (res) {
        setValue(3);

      } else {
        setValue(0)
        NotifyError(General?.codeLabels['cm_mofailed1']?.label)
      }
    } catch (error) {
      setValue(0)
      NotifyError(General?.codeLabels['cm_mofailed1']?.label)
    }

  };
  const [paymentLoader, setPaymentLoader] = useState(false)
  const handleMoveOutPayment = async ({
    token,
    cvv,
    type,
    paymentRequestType,
  }: {
    token: string;
    cvv?: string;
    type?: string;
    paymentRequestType?: number;
  }) => {
    setPaymentLoader(true)
    const moveOutInfo = MoveInOut.moveOutInfo;

    const moveOutDues = MoveInOut.moveOutDues;

    // Parse the date string and format it to ISO format
    var serviceTerminationDate = new Date(
      moveOutInfo.serviceTerminationDate
    ).toISOString();

    const data = {
      token: token,
      transactionId: General?.otpResult?.transactionId,
      amount: moveOutDues.totalAmountTobePaid,
      paymentRequestType: paymentRequestType, //1 = not from saved cards
      // cvv: cvv,
      type: type,
      sewerageId: moveOutInfo.premiseId,
      serviceTerminationDate: serviceTerminationDate,
      isNOCSelected: true,
      accountId: moveOutInfo.accountId,
      estimatedBillId: moveOutDues.estimatedBillId,
      // customerAddress: moveOutInfo.customerAddress,
      customerAddress: null,
    };
    try {
      await MoveInOut.moveOutPayment({ errorId: "moveOutPaymentError", data });
      setPaymentLoader(false)
    } catch (error) {
      setPaymentLoader(false)
    }

  };

  const reviewFeeHandler = () => {
    if (MoveInOut.moveOutDues.totalAmountTobePaid || MoveInOut.moveOutDues.totalAmountTobePaid === 0) {
     
      setValue(2);
    }
  };

  useEffect(() => {
    General.incrementServiceUsage("5");
    loadSewerageNumber();
  }, []);

  useEffect(() => {
    if (MoveInOut.paymentResponseMoveOut.redirectUrl) {
      //.success
      if (MoveInOut.paymentResponseMoveOut.redirectUrl) {
        window.open(MoveInOut.paymentResponseMoveOut.redirectUrl, "_self");

        //proceed to moveout
      } else handleMoveOut();
    }
  }, [MoveInOut.paymentResponseMoveOut]);
  const [refernceValue, setReferenceValue] = useState()
  const handlePayment3Ds = async (code: any) => {
    const response = await moveInOutStore.payment3Ds(code);
    let paymentId = response.result.paymentId;
    setReferenceValue(paymentId)
    const transactionId = response.result.paymentId;
    let successMessage =
      "Thank you. Your payment has been successfully processed.<br> Payment ID:";
    successMessage = successMessage + paymentId;
    // alert(successMessage);
  };
  const [downloadLoader, setDownloadLoader] = useState(false);

  const downloadBillPDF = async () => {
    setDownloadLoader(true);
    try {

      const data = { id: `${MoveInOut?.moveOutResponse?.id}` ,orderId: `${MoveInOut?.moveOutResponse?.orderId}` };
      const res: any = await AccountsNotifications?.downloadNOCAndMoveout(data);
      setTimeout(() => { setDownloadLoader(false) }, 5000)
      if (!res) {
        setDownloadLoader(false)
        // NotifyError(General?.codeLabels['cm_servererror']?.label)
      }
    } catch (error) {
      setDownloadLoader(false)
      NotifyError(General?.codeLabels['cm_servererror']?.label)
    }


  };
  
  useEffect(() => {
    if (window.location.href.includes("cko-session-id=")) {
      let locationUrl = window.location.href;
      console.log("get response a hit is seen successs", window.location.href);
      let code = locationUrl.split("cko-session-id=")[1];
      handlePayment3Ds(code);
    }
  }, []);

  useEffect(() => {
    if (orderIDParam) {
      setValue(3);
    }
    return;
  }, []);
  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;
  return (
    <>
      <MoveInHeader
        style={{
          color: General.contrast.contrastColor
            ? General.contrast.contrastColor
            : '#fff',
          background: General.contrast.contrastBackground
            ? General.contrast.contrastBackground
            : ColorAss === '#101E8E'? '#62aa51': General?.ColorAss
        }}
      >
        <div>
          <MiniNav>
            <ButtonSecondary
              style={{

                width: "81px",
                height: "30px",
                border: "1px solid #FFF",
                fontSize: `${General.accessibility.fontSize}rem`,
                zIndex: "0",
                color: contrast?.contrastBackground ? contrast?.contrastBackground : "#fff", background: contrast?.contrastColor ? contrast?.contrastColor : 'rgba(98, 170, 81, 1)',
              }}
              onClick={() => navigate('/dashboard', { state: { fromRefund: true } })}
            >
              {General?.codeLabels["cm_back"]?.label ? General?.codeLabels["cm_back"]?.label : "BACK"}
            </ButtonSecondary>
            {User?.info?.personId && <ButtonSecondary
              style={{
                color: contrast?.contrastBackground ? contrast?.contrastBackground : "#fff", background: contrast?.contrastColor ? contrast?.contrastColor : 'rgba(98, 170, 81, 1)',
                width: General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA" ? "12rem" : "117px",
                height: "30px",
                border: "1px solid #FFF",
                fontSize: `${General.accessibility.fontSize}rem`,
                zIndex: "0"
              }}
              onClick={() => navigate("/dashboard")}
            >
              {General?.codeLabels["cm_dashboard"]?.label ? General?.codeLabels["cm_dashboard"]?.label : "DASHBOARD"}
            </ButtonSecondary>}
          </MiniNav>
          <h1
            style={{
              fontFamily: "Segoe UI",
              fontStyle: "normal",
              fontWeight: "400",
              fontSize: General?.isLargeScreen ? `${3.1 * General.accessibility.fontSize}rem` : `${2 * General.accessibility.fontSize}rem`,
              margin: "0",
              color: contrast?.contrastColor ? contrast?.contrastColor : ""
            }}
          >
            {General?.codeLabels["cm_moveout"]?.label !== undefined
              ? General?.codeLabels["cm_moveout"]?.label
              : "Move Out"}
            (
            {General?.codeLabels["cm_mob_st"]?.label !== undefined
              ? General?.codeLabels["cm_mob_st"]?.label
              : "Service Termination"}
            )
          </h1>
        </div>
      </MoveInHeader>
      <ComplaintContainer style={{ backgroundColor:value === 3 ?"#eeeeee": contrast?.contrastBackground ? contrast?.contrastBackground : '#fff', width: General?.isLargeScreen ? "" : "100%" }}>
        <Box
          sx={{
            width: General?.isLargeScreen ? "80%" : "100%",
            marginTop: General?.isLargeScreen ? "40px" : "1rem",

          }}
        >
          {value !== 3 && <Box
            sx={{
              display: "flex",
              width: '100%',
              justifyContent: General?.isLargeScreen ? '' : "center"
            }}
          >
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
              sx={{
                alignSelf: "flex-end",
                marginBottom: "0px",
                zIndex: "0",
                width: { md: '70%', lg: '100%' }
              }}
              variant="scrollable"
              // scrollButtons
              allowScrollButtonsMobile
            >
              <Tab
                label={
                  <TabWithCount value={value} count={1}>
                    {General?.isLargeScreen && <span
                      style={{
                        fontSize: `${General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor ? contrast?.contrastBackground : General?.ColorAss,
                      }}
                    >
                      {General?.codeLabels["cm_propertydet"]?.label !==
                        undefined
                        ? General?.codeLabels["cm_propertydet"]?.label
                        : "Property Details"}
                    </span>}
                  </TabWithCount>
                }
                // className="mui-move-in"
                {...a11yProps(0)}
                sx={{
                  background: General?.isLargeScreen ? contrast?.contrastColor ? contrast?.contrastColor : "#e7e9f8" : "",
                  color: contrast?.contrastBackground ? contrast?.contrastBackground : "#101e8e",
                  margin: "0.2rem",
                  marginBottom: "0",
                  width: "32.5%",
                  "&.Mui-selected": {
                    outline: "none",
                  },
                }}
                disabled={value == 1 ? false : true}
              />
              <Tab
                label={
                  <TabWithCount count={2} value={value}>

                    {General?.isLargeScreen && <span
                      style={{
                        fontSize: `${General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor ? contrast?.contrastBackground : General?.ColorAss,
                      }}
                    >
                      {General?.codeLabels["cm_estimated_fee"]?.label ? General?.codeLabels["cm_estimated_fee"]?.label : "Review Estimated Fees"}
                    </span>}
                  </TabWithCount>
                }
                // className="mui-move-in"
                {...a11yProps(1)}
                sx={{
                  background: General?.isLargeScreen ? contrast?.contrastColor ? contrast?.contrastColor : "#e7e9f8" : "",
                  color: contrast?.contrastBackground ? contrast?.contrastBackground : "#101e8e",
                  margin: "0.2rem",
                  marginBottom: "0",
                  width: "32.5%",
                  zIndex: "0",
                  "&.Mui-selected": {
                    outline: "none",
                  },
                }}
                disabled={value == 2 ? false : true}
              />
              <Tab
                label={
                  <TabWithCount className="DynamicTextColor" count={3} value={value}>
                    {General?.isLargeScreen && <span
                      style={{
                        fontSize: `${General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor ? contrast?.contrastBackground : General?.ColorAss,
                      }}
                    >
                      {General?.codeLabels["cm_verify_pay"]?.label ? General?.codeLabels["cm_verify_pay"]?.label : "Verify & Pay"}
                    </span>}
                  </TabWithCount>
                }
                // className="mui-move-in"
                {...a11yProps(2)}
                sx={{
                  background: General?.isLargeScreen ? contrast?.contrastColor ? contrast?.contrastColor : "#e7e9f8" : "",
                  color: contrast?.contrastBackground ? contrast?.contrastBackground : "#101e8e",
                  margin: "0.2rem",
                  marginBottom: "0",
                  width: "32.5%",
                  zIndex: "0",
                  "&.Mui-selected": {
                    outline: "none",
                  },
                }}
                disabled={value == 3 ? false : true}
              />
            </Tabs>
          </Box>}

          <TabPanel value={value} index={0}>
            
            <PropertyDetails
            sewerageNumbers={MoveInOut.sewerageNumbers}
            sewerageRef={sewerageNumberRef}
            getDetails={handleGetDetails}
            validateLoader={validateLoader}
            Next={() => setValue(1)}
            fileUpload={fileUpload}
              uploadDocs={handleUploadDocs}
              message={message}
          />
            
          </TabPanel>
          <TabPanel value={value} index={1}>
            <Reviews
              dues={MoveInOut.moveOutDues}
              loadMoveOutDues={loadMoveOutDues}
              Next={() => reviewFeeHandler()}
              Previous={() => {
                setValue(0);
                MoveInOut?.removeMoveOutDues()
              }}
              sewerageNumber={sewerageValue}
              duesLoader={duesLoader}
            />
          </TabPanel>
          <TabPanel value={value} index={2}>
            <VerifyAndPay
              premiseId={MoveInOut.moveOutInfo.premiseId}
              email={User.profile.email as string}
              mobile={User.profile.mobileNumber as string}
              personID={User.info.personId as string}
              isModal={false}
              Previous={() => {
                setValue(1)
                MoveInOut?.removeMoveOutDues()
              }}
              isMoveOut = {true}
              onVerify={moveOutOtpVerified}
            />
          </TabPanel>
          <TabPanel value={value} index={3} width="100%">
            <Thankyou
              title={statusMessage?.message 
              ? General?.codeLabels[statusMessage.message]?.label?.replace('{0}', statusMessage.caseId) 
              : General?.codeLabels["cm_moveout_success"]?.label 
              ? General?.codeLabels["cm_moveout_success"]?.label?.replace('{0}', MoveInOut?.moveOutResponse?.orderId)?.replace('{1}', MoveInOut?.moveOutResponse?.email) 
              : "Thank You"
              }
              referenceId={statusMessage?.caseId || MoveInOut?.moveOutResponse?.orderId}
              serviceID={serviceId}
              downloadLoader={downloadLoader}
              downloadBillPDF={downloadBillPDF}
            />
          </TabPanel>
        </Box>
      </ComplaintContainer>

      <Modal
        open={openCards}
        onClose={(event, reason) => {
                    if (reason === "backdropClick") return;
                    handleCardsModalClose();
                  }}
      // onClick={handleClose}
      disableEscapeKeyDown
      >
        {config?.isCheckout ?(<CardsPopup
          onClose={handleCardsModalClose}
          makePayment={handleMoveOutPayment}
          fromAutoPay={false}
          amount={MoveInOut.moveOutDues?.totalAmountTobePaid}
          paymentLoader={paymentLoader}
          emailForm={false}
        />):(<div className="p-4">
        <GatewaySelection
          onClose={handleCardsModalClose}
          paymentData={paymentDataForGateway}
          handlePayment={handlePaymentInitiation}
          user={User} 
          checkTabbyEligibility={checkTabbyEligibility}
          checkTamaraEligibility={checkTamaraEligibility}
          
        />
        </div>)}
        
        
      </Modal>
    </>
  );
};

export default observer(MoveOutTermination);
